/**
 * Single active-state rule for sidebar links outside the project steps.
 *
 * Hub pages (a settings home, the projects list) match exactly so they do
 * not light up for every child route. Other pages match themselves and their
 * subpaths on a full segment boundary: `/script` never matches `/script-notes`.
 */
export function isNavPathActive(
  pathname: string,
  href: string,
  options?: { exact?: boolean }
): boolean {
  const normalizedPath = pathname.replace(/\/+$/, "") || "/";
  const normalizedHref = href.replace(/\/+$/, "") || "/";
  if (normalizedPath === normalizedHref) return true;
  if (options?.exact) return false;
  return normalizedPath.startsWith(`${normalizedHref}/`);
}

/**
 * Active rule for a settings section link. The hub section also owns its
 * `/general` alias (workspace settings serve the overview at both paths).
 */
export function isSettingsSectionActive(
  pathname: string,
  sectionHref: string,
  isHubSection: boolean
): boolean {
  if (!isHubSection) {
    return isNavPathActive(pathname, sectionHref);
  }
  return (
    isNavPathActive(pathname, sectionHref, { exact: true }) ||
    isNavPathActive(pathname, `${sectionHref.replace(/\/+$/, "")}/general`)
  );
}
